import { useState } from 'react';
import { useCallback } from 'react';

export const useSearchValueState = (): {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  clear: VoidFunction;
} => {
  const [searchText, setSearchText] = useState<string>('');
  const onChange = useCallback((e: any) => setSearchText(e.target.value), []);
  const clearSearch = useCallback(() => setSearchText(''), []);

  return {
    value: searchText,
    onChange,
    clear: clearSearch,
  };
};
